// src/js/main.js

// --- Importamos todos los módulos ---
import initSearchModal from "./modules/search-modal.js";
import initNavOverlay from "./modules/nav-overlay.js";
import initThemeToggle from "./modules/theme-toggle.js";
import initCopyRss from "./modules/copy-rss.js";
import initScrollToTop from "./modules/scrollToTop.js";
import initRelatedPosts from "./modules/related-posts.js";
import initDynamicHeader from "./modules/dynamic-header.js";
import initEmailObfuscation from "./modules/email-obfuscation.js";
import initCopyUrl from "./modules/copy-url.js";
import initPrintButton from "./modules/print-button.js";
import initNativeShare from "./modules/native-share.js";
import initExternalLinks from "./modules/external-links.js";


// --- Envolvemos todo en DOMContentLoaded para máxima seguridad ---
document.addEventListener("DOMContentLoaded", () => {
  console.log(
    "KAIMIRU.JS: DOMContentLoaded disparado. Inicializando módulos...",
  );

  // Un objeto que mapea el nombre de la función a la función misma
  const modules = {
    initSearchModal,
    initNavOverlay,
    initThemeToggle,
    initCopyRss,
    initScrollToTop,
    initRelatedPosts,
    initDynamicHeader,
    initEmailObfuscation,
    initCopyUrl,
    initPrintButton,
    initNativeShare,
    initExternalLinks,
  
  };

  // Iteramos sobre cada módulo y lo ejecutamos dentro de un try...catch
  for (const [name, func] of Object.entries(modules)) {
    try {
      func();
    } catch (e) {
      // Si un módulo falla, la consola nos dirá EXACTAMENTE cuál fue
      console.error(`Error al inicializar el módulo: ${name}`, e);
    }
  }

  console.log("KAIMIRU.JS: Todos los módulos han sido llamados.");
});
